import React from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { pathByRouteName } from '../../../../util/routes';

import css from './TopbarBackButton.module.css';

/**
 * DIGO: a simple left-arrow "back" button used in the main Topbar (mobile + desktop).
 * Returns to the previous page, falling back to the landing page when there is no
 * history (e.g. the page was opened directly from a link or the mobile app).
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - extra class for the button
 * @returns {JSX.Element}
 */
const TopbarBackButton = props => {
  const { className } = props;
  const history = useHistory();
  const intl = useIntl();
  const routeConfiguration = useRouteConfiguration();

  const label = intl.formatMessage({ id: 'TopbarSimplified.back' });

  const handleBack = () => {
    const canGoBack = typeof window !== 'undefined' && window.history && window.history.length > 1;
    if (canGoBack) {
      history.goBack();
    } else {
      history.push(pathByRouteName('LandingPage', routeConfiguration));
    }
  };

  return (
    <button
      type="button"
      className={classNames(css.backButton, className)}
      onClick={handleBack}
      aria-label={label}
      title={label}
    >
      <svg
        className={css.backIcon}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <line x1="20" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
    </button>
  );
};

export default TopbarBackButton;
